import { showDialog } from '@components/dialog';
import { PreviewAvailableTimesChange } from 'client/cal/availability-summary';
import { AvailabilityRow } from 'server/types/cal-schema';

export async function ChangeAvailableTimesModal({
  originalTimezone,
  selectedTimezone,
  availabilityBlocks,
}: {
  originalTimezone: string;
  selectedTimezone: string;
  availabilityBlocks: AvailabilityRow[];
}) {
  return await showDialog({
    mode: 'warn',
    title: 'Timezone change',
    children: (
      <div>
        <p class="mb-2">
          You've changed your timezone from {originalTimezone} to {selectedTimezone}. Your
          availability will update to maintain your local hours, is this correct?
        </p>
        <div class="space-y-4">
          {availabilityBlocks.map((avail) => (
            <div
              key={avail.id}
              className="rounded-lg border border-gray-200 p-4 shadow-sm hover:shadow-md transition"
            >
              <div className="flex flex-col space-y-3">
                <span className="text-gray-900 font-semibold">{avail.name}</span>
                <PreviewAvailableTimesChange
                  renderTimeZone={avail.timezone}
                  scheduleTimeZone={selectedTimezone}
                  timeslots={avail.timeslots}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    ),
    confirmButtonText: 'Yes, update my hours',
    cancelButtonText: 'No, keep absolute times',
  });
}
